import { render, staticRenderFns } from "./VehicleInfoTab.vue?vue&type=template&id=534abd50&scoped=true&"
import script from "./VehicleInfoTab.vue?vue&type=script&lang=js&"
export * from "./VehicleInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInfoTab.vue?vue&type=style&index=0&id=534abd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534abd50",
  null
  
)

export default component.exports